import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=7cd8bda0&scoped=true"
import script from "./Servicios.vue?vue&type=script&lang=js"
export * from "./Servicios.vue?vue&type=script&lang=js"
import style0 from "./Servicios.vue?vue&type=style&index=0&id=7cd8bda0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8bda0",
  null
  
)

export default component.exports